/// <reference path="../_references.ts"/>

module App.Utils {
	export class OrganizationService {
		constructor(
			public $http: ng.IHttpService,
			public Constants: IConstants,
		){}

		public getPriceCardText(): ng.IHttpPromise<OrganizationSSPTextData> {
			return this.$http.get(`${this.Constants.apiUrl}organization/current`, {
				params: {
					quiet: 1,
					show_field_text: 1,
				},
			});
		}

		public getCallsourceDetails(): ng.IHttpPromise<OrganizationCallsourceData> {
			return this.$http.get(`${this.Constants.apiUrl}organization/current/callsource`);
		}

		public getSRDisplayDetails(): ng.IHttpPromise<OrganizationSRDisplayData> {
			return this.$http.get(`${this.Constants.apiUrl}organization/current/srdisplay`);
		}

		public getETCSettingDetails(): ng.IHttpPromise<OrganizationETCSettingData> {
			return this.$http.get(`${this.Constants.apiUrl}organization/current/etcsetting`);
		}

		public getFileUploadDetails(): ng.IHttpPromise<OrganizationFileUploadData> {
			return this.$http.get(`${this.Constants.apiUrl}organization/current/filesetting`);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new OrganizationService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}